/**
 * Firebase Client — DEAD CODE STUB.
 *
 * Firebase is no longer used; Supabase is the live path. Exports kept for
 * compatibility. No SDK loaded, no throw at module load.
 */

export function getClientApp(): any | undefined {
  return undefined;
}

export function getClientAuth(): any | undefined {
  return undefined;
}

export function getClientStorage(): any | undefined {
  return undefined;
}

export function getClientDb(): any | undefined {
  return undefined;
}

export function isClientFirebaseAvailable(): boolean {
  return false;
}

export async function ensureFirebaseInitialized(): Promise<boolean> {
  return false;
}

export default {
  getClientApp,
  getClientAuth,
  getClientStorage,
  getClientDb,
  ensureFirebaseInitialized,
  isClientFirebaseAvailable,
};
